export type Country = { code: string; name: string; dialCode: string };

export const COUNTRIES: Country[] = [
  { code: 'ES', name: 'España', dialCode: '+34' },
  { code: 'MX', name: 'México', dialCode: '+52' },
  { code: 'AR', name: 'Argentina', dialCode: '+54' },
  { code: 'CO', name: 'Colombia', dialCode: '+57' },
  { code: 'CL', name: 'Chile', dialCode: '+56' },
  { code: 'PE', name: 'Perú', dialCode: '+51' },
  { code: 'EC', name: 'Ecuador', dialCode: '+593' },
  { code: 'VE', name: 'Venezuela', dialCode: '+58' },
  { code: 'UY', name: 'Uruguay', dialCode: '+598' },
  { code: 'PY', name: 'Paraguay', dialCode: '+595' },
  { code: 'BO', name: 'Bolivia', dialCode: '+591' },
  { code: 'CR', name: 'Costa Rica', dialCode: '+506' },
  { code: 'PA', name: 'Panamá', dialCode: '+507' },
  { code: 'GT', name: 'Guatemala', dialCode: '+502' },
  { code: 'HN', name: 'Honduras', dialCode: '+504' },
  { code: 'SV', name: 'El Salvador', dialCode: '+503' },
  { code: 'NI', name: 'Nicaragua', dialCode: '+505' },
  { code: 'DO', name: 'República Dominicana', dialCode: '+1' },
  { code: 'CU', name: 'Cuba', dialCode: '+53' },
  { code: 'PR', name: 'Puerto Rico', dialCode: '+1' },
  { code: 'US', name: 'Estados Unidos', dialCode: '+1' },
  { code: 'CA', name: 'Canadá', dialCode: '+1' },
  { code: 'BR', name: 'Brasil', dialCode: '+55' },
  { code: 'PT', name: 'Portugal', dialCode: '+351' },
  { code: 'FR', name: 'Francia', dialCode: '+33' },
  { code: 'DE', name: 'Alemania', dialCode: '+49' },
  { code: 'IT', name: 'Italia', dialCode: '+39' },
  { code: 'GB', name: 'Reino Unido', dialCode: '+44' },
  { code: 'NL', name: 'Países Bajos', dialCode: '+31' },
  { code: 'BE', name: 'Bélgica', dialCode: '+32' },
  { code: 'CH', name: 'Suiza', dialCode: '+41' },
  { code: 'AT', name: 'Austria', dialCode: '+43' },
  { code: 'IE', name: 'Irlanda', dialCode: '+353' },
  { code: 'GR', name: 'Grecia', dialCode: '+30' },
  { code: 'SE', name: 'Suecia', dialCode: '+46' },
  { code: 'NO', name: 'Noruega', dialCode: '+47' },
  { code: 'DK', name: 'Dinamarca', dialCode: '+45' },
  { code: 'FI', name: 'Finlandia', dialCode: '+358' },
  { code: 'PL', name: 'Polonia', dialCode: '+48' },
  { code: 'RU', name: 'Rusia', dialCode: '+7' },
  { code: 'UA', name: 'Ucrania', dialCode: '+380' },
  { code: 'JP', name: 'Japón', dialCode: '+81' },
  { code: 'CN', name: 'China', dialCode: '+86' },
  { code: 'IN', name: 'India', dialCode: '+91' },
  { code: 'KR', name: 'Corea del Sur', dialCode: '+82' },
  { code: 'TR', name: 'Turquía', dialCode: '+90' },
  { code: 'IL', name: 'Israel', dialCode: '+972' },
  { code: 'AE', name: 'Emiratos Árabes Unidos', dialCode: '+971' },
  { code: 'MA', name: 'Marruecos', dialCode: '+212' },
  { code: 'GQ', name: 'Guinea Ecuatorial', dialCode: '+240' },
  { code: 'ZA', name: 'Sudáfrica', dialCode: '+27' },
  { code: 'AU', name: 'Australia', dialCode: '+61' },
  { code: 'NZ', name: 'Nueva Zelanda', dialCode: '+64' },
];
